import ExamPartResult from './ExamPartResult';

export default class ExamResult {

    constructor() {
        this.id = null;
        this.title = null;
        this.status = null;
        this.note = null;
        this.examDate = null;
        this.type = null;
        this.sport = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const result = new ExamResult();
        result.id = data.id;
        result.title = data.title;
        result.status = data.status;
        result.note = data.note;
        result.examDate = data.examDate;
        result.type = data.type;
        result.sport = data.sport;
        if (data.clubExamPartResults) {
            result.examPartResults = data.clubExamPartResults.map((part) => ExamPartResult.fromData(part))
        }

        return result;
    }

    serialize() {
        return {
            id: this.id,
            status: this.status,
            examDate: this.examDate,
            note: this.note,
            examPartResults: this.examPartResults.map((part) => part.serialize())
        }
    }
}
